import React, {useContext, useState} from 'react'
import "../styles/formContatto.scss"
import {Languages} from "./Home"
import { ApiCall } from '../Utils';

export default function FormContatto() {
    const lang = useContext(Languages)

    const [form, setForm] = useState({
        nome: "",
        mail:"",
        telefono: "",
        messaggio: ""
    })
    const [campiErrori, setCampiErrori] = useState([])
    const [errori, setErrori] = useState([])
    const [msgInvio, setMsgInvio] = useState("")
    const [loading, setLoading] = useState(false)


    const onChange = (e) => {
        setForm(prevForm=>{
            return {
                ...prevForm,
                [e.target.name]: e.target.value
            }
        })
    }

    async function sendMessage(e){
        setLoading(true)
        e.preventDefault()
        let esito = await controlliFormali()
        esito && exec_submitForm()
    }

    const controlliFormali = async() => {
        let errori = []
        let campi = []
        if(!form.mail){
            errori.push(/*lang.empty_email*/"Inserisci un indirizzo email")
            campi.push("mail")
        }
        if(form.tel){
            if(!containsOnlyNumbers(form.telelefono)){
                errori.push(/*lang.err_numbers*/"Inserisci un numero di telefono valido")
                campi.push("telefono")
            }   
        }

        let checkMail = isValidEmail(form.mail)
        if(!checkMail){
            errori.push(/*lang.empty_email*/"L'indirizzo mail inserito non è formalmente corretto")
            campi.push("mail")
        }

        setCampiErrori(campi)
        setErrori(errori)
        
        if(errori.length > 0){
            setLoading(false)
            return false
        }else{
            return true
        }
    }

    function isValidEmail(email) {
        // Definiamo una regolare espressione per le email
        var emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
        
        // Utilizziamo il metodo test per verificare se la stringa corrisponde al pattern
        return emailRegex.test(email);
      }

    const exec_submitForm = async() =>{
        try{
            const res = await ApiCall(`sendMail`, form, "POST")
            setLoading(false)
            if(res.data.ok){
                setMsgInvio(/*lang.msg_invio*/"Email inviata correttamente")
                setForm({ nome: "",
                telefono: "",
                mail: "",
                messaggio: ""})
                setTimeout(()=>{setMsgInvio("")},5000)
                
            }else{
                setErrori([res.data.err])
                setMsgInvio(/*lang.msg_invio*/"Qualcosa è andato storto, riprovare o chiamare il numero \n 02 8201 5719")
                setTimeout(()=>{setMsgInvio("")},5000)
            }
        }catch{
            setMsgInvio(/*lang.msg_invio*/"Qualcosa è andato storto, riprovare o chiamare il numero \n 02 8201 5719")
        }
    }

    const containsOnlyNumbers = (str) => {
        return /^\d+$/.test(str);
    }

    return (
        <div className='form_contatto_section max-w' >
            <span data-aos="zoom-out-up"  data-aos-duration="1000">
            <div className='form_contatto row'>
                {msgInvio !== "" ? 
                <div className='testo_generico testo_messaggio_mail'>
                    {msgInvio}
                    <div className='button_form_container'><button  onClick={()=>{setMsgInvio("")}} className='button_outline'>OK</button></div>
                </div>
                :
                <>
                <div className='col input_form_contatto' id="contatti">
                    <input className={'input_outline' + (loading ? " input_sending" : "")} placeholder='Nome' name="nome" value={form.nome} onChange={onChange} disabled={loading}/></div>
                <div className='col input_form_contatto'>
                    <input className={'input_outline' + (campiErrori.includes("mail") ? " input_error" : "")+ (loading ? " input_sending" : "")} placeholder='Mail' name="mail" type="email" value={form.mail} onChange={onChange} disabled={loading}/></div>
                <div className='col input_form_contatto'>
                    <input className={'input_outline'  + (campiErrori.includes("telefono") ? " input_error" : "")+ (loading ? " input_sending" : "")} placeholder='Telefono' name="telefono" value={form.telefono} onChange={onChange} disabled={loading}/></div>
                <div className='col textarea_form_contatto'>
                    <textarea rows={5} className={'textarea_outline'+ (loading ? " input_sending" : "")} placeholder='Messaggio...' name="messaggio" value={form.messaggio} onChange={onChange} disabled={loading}/></div>
                <div className='button_form_container'><button  onClick={sendMessage} className={'button_outline' + (loading ? " button_outline_gray" : "")} disabled={loading}>{lang['INVIA RICHIESTA']}</button></div>
                </> }
            </div>
            </span>
            <p className='testo_generico test_form_contatti at_c' data-aos="zoom-out-up" data-aos-duration="1000">{lang["Se pensi che attendere"]} <a href='tel:0282015719' style={{fontSize: "larger"}}><b>02&nbsp;8201&nbsp;5719</b></a> </p>
        </div>
        
    )
}
